export default {
    small: {
        width: '28px',
        height: '28px',
    },
    medium: {
        width: '32px',
        height: '32px',
    },
    large: {
        width: '40px',
        height: '40px',
    },
    xl: {
        width: '56px',
        height: '56px',
    },
};
